/**
 * Custom slider navigation script for managing slider functionality.
 * This script dynamically adds "Previous" and "Next" buttons, positioning
 * the "Previous" button above the slider and the "Next" button below it.
 * These buttons allow users to navigate through slides in a circular manner.
 */

document.addEventListener('DOMContentLoaded', () => {
  // Select the slider container with stable class selectors
  const sliderGallery = document.querySelector('.product__media-list.slider--mobile');
  
  // Select all individual slides within the slider
  const sliderItems = sliderGallery.querySelectorAll('.slider__slide');
  
  // Index to keep track of the currently active slide
  let currentIndex = 0;

  /**
   * Function to update the active slide.
   * It toggles the 'is-active' class to ensure only one slide is visible at a time.
   * @param {number} index - The index of the slide to activate.
   */
  function updateActiveSlide(index) {
    sliderItems.forEach((item, idx) => {
      item.classList.toggle('is-active', idx === index);
    });
  }

  // Create the "Previous" button
  const prevButton = document.createElement('button');
  prevButton.className = 'slider-controls__button slider-controls__button--prev'; // BEM: Element "__button", Modifier "--prev"
  prevButton.setAttribute('aria-label', 'Previous'); // Accessibility label for screen readers

  // Add SVG arrow icon for "Previous"
  prevButton.innerHTML = `
    <svg class="icon icon-caret" viewBox="0 0 10 6" aria-hidden="true">
      <path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"></path>
    </svg>
  `;

  // Attach click event to navigate to the previous slide
  prevButton.addEventListener('click', () => {
    currentIndex = (currentIndex === 0) ? sliderItems.length - 1 : currentIndex - 1;
    updateActiveSlide(currentIndex);
  });

  // Create the "Next" button
  const nextButton = document.createElement('button');
  nextButton.className = 'slider-controls__button slider-controls__button--next'; // BEM: Element "__button", Modifier "--next"
  nextButton.setAttribute('aria-label', 'Next'); // Accessibility label for screen readers

  // Add SVG arrow icon for "Next"
  nextButton.innerHTML = `
    <svg class="icon icon-caret" viewBox="0 0 10 6" aria-hidden="true">
      <path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"></path>
    </svg>
  `;

  // Attach click event to navigate to the next slide
  nextButton.addEventListener('click', () => {
    currentIndex = (currentIndex === sliderItems.length - 1) ? 0 : currentIndex + 1;
    updateActiveSlide(currentIndex);
  });

  // Insert the "Previous" button above the slider
  sliderGallery.parentNode.insertBefore(prevButton, sliderGallery);

  // Insert the "Next" button below the slider
  sliderGallery.parentNode.insertBefore(nextButton, sliderGallery.nextSibling);

  // Initialize the first slide as active
  updateActiveSlide(currentIndex);
});
